import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import Panel from "Portal/NewPortal/Shared/Panel";

import { HiResAvatarIcon, Div, Text2 } from "components/Base";
import styles from "./styles.scss";
import CSSModules from "react-css-modules";

import {
  getPortalUserName,
  getPortalUserEmail,
  getPortalUserPhoto,
  getActiveAccount,
  getProfilePanelTitle,
  getPortalUserTitle,
  getPortalUserCompany,
  getPortalUserDescription
} from "Portal/NewPortal/HeaderBar/selectors";

import {
  getSectionIconById,
  getAccentColor,
  getIsManageProfileEnabled
} from "Portal/NewPortal/PortalHome/selectors";

import { isEmptyOrNil } from "utils/General";

import { actions } from "Portal/NewPortal/PortalHome/model";

import { SECTIONS_IDS } from "Portal/NewPortal/PortalHome/constants";

import { noop } from "utils/General";

const decorate = R.compose(
  CSSModules(styles),
  connect(
    state => ({
      panelTitle: getProfilePanelTitle(state),
      name: getPortalUserName(state),
      email: getPortalUserEmail(state),
      title: getPortalUserTitle(state),
      company: getPortalUserCompany(state),
      description: getPortalUserDescription(state),
      photoUrl: getPortalUserPhoto(state),
      activeAccount: getActiveAccount(state),
      accentColor: getAccentColor(state),
      isManageProfileEnabled: getIsManageProfileEnabled(state)
    }),
    {
      onClickPanelHeader: actions.setSelectedCategory
    }
  )
);

const Profile = ({
  name = "",
  email = "",
  title,
  company,
  description,
  photoUrl = null,
  onClickPanelHeader = noop,
  activeAccount = null,
  panelTitle,
  accentColor,
  isManageProfileEnabled
}) => {
  const displayName = activeAccount ? activeAccount.name : name;
  const displayEmail = activeAccount ? activeAccount.email : email;
  const displayPhotoUrl = activeAccount ? activeAccount.photo_url : photoUrl;

  const activeAccountType = R.pathOr(
    undefined,
    ["type", "name"],
    activeAccount
  );

  const icon = activeAccountType ? "groups" : getSectionIconById("profile");

  return (
    <Panel
      title={panelTitle}
      panelContainerStyle={{
        maxHeight: "400px",
        height: "auto",
        overflow: "auto"
      }}
      icon={icon}
      onClickHeader={
        isManageProfileEnabled
          ? () => onClickPanelHeader({ category: SECTIONS_IDS.PROFILE })
          : undefined
      }
    >
      <div className={styles.profileContainer}>
        <div className={styles.profileHeader}>
          {!isEmptyOrNil(displayPhotoUrl) ? (
            <img
              className={styles.profileImage}
              src={displayPhotoUrl}
              alt={displayName}
            />
          ) : (
            <HiResAvatarIcon className={styles.profileImage} />
          )}
          <div className={styles.profileHeaderTextContainer}>
            <div className={styles.profileNameContainer}>
              <div className={styles.profileName}>{displayName}</div>
            </div>
            {displayEmail && displayEmail.length && (
              <div className={styles.profileEmail}>{displayEmail}</div>
            )}
          </div>
        </div>
        {title && title.length && company && company.length ? (
          <>
            <div className={styles.profileDivider}></div>
            <div className={styles.profileDetails}>
              {title && title.length ? (
                <div className={styles.profileDetailText}>{title}</div>
              ) : null}
              {company && company.length ? (
                <div className={styles.profileDetailText}>{company}</div>
              ) : null}
            </div>
          </>
        ) : null}
        {description && description.length ? (
          <>
            <div className={styles.profileDivider}></div>
            <div className={styles.profileDescription}>
              <span
                className="lennd-wysiwyg-content"
                style={{ whiteSpace: "pre-wrap" }}
                dangerouslySetInnerHTML={{
                  __html: description
                }}
              />
            </div>
          </>
        ) : null}

        {isManageProfileEnabled ? (
          <Div width={1}>
            <Text2
              bold
              color={accentColor}
              onClick={() =>
                onClickPanelHeader({ category: SECTIONS_IDS.PROFILE })
              }
            >
              View more
            </Text2>
          </Div>
        ) : null}
      </div>
    </Panel>
  );
};

export default decorate(Profile);
